import {ValueObject} from '@s-ui/domain'

import {InvalidPhoneSellerError} from '../Errors/InvalidPhoneSellerError.js'

export class UpdateInstantOfferPhoneSellerRequest extends ValueObject {
  #phone

  constructor({phone}) {
    super()
    this.#phone = phone
  }

  static create = ({config, phone}) => {
    const isValidPhone = config.get('REGEX_MOBILE_PHONE').test(phone ?? '')
    if (!isValidPhone) throw new InvalidPhoneSellerError('[UpdateInstantOfferPhoneSellerRequest] Invalid phone')

    return new UpdateInstantOfferPhoneSellerRequest({phone})
  }

  toJSON() {
    return {phone: this.#phone}
  }
}
